<template>
  <div class="page" :style="bgStyle">
    <!-- Los botones se posicionan sobre el fondo, lado derecho arriba de la foto -->
    <div class="botones-col">
      <img
        src="/mexa/boton-encuesta.png"
        class="btn-nav"
        alt="Encuesta"
        @click="$router.push('/encuesta')"
      />
      <div class="btn-foto-wrap">
        <img
          src="/mexa/pasa_foto.png"
          class="btn-nav"
          alt="Fotos"
          @click="irAFotos"
        />
        <span v-if="mostrarAviso" class="btn-foto-aviso">¡Aguas! Primero suéltalo sin filtro</span>
      </div>
      <img
        src="/mexa/boton-video.png"
        class="btn-nav"
        alt="Video"
        @click="$router.push('/video?modo=video')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InicioView',
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      mostrarAviso: false
    }
  },
  computed: {
    bgStyle() {
      const img = this.isMobile ? '/mexa/fondo-inicio-movil.jpg' : '/mexa/nuevofondo.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768
    },
    irAFotos() {
      if (localStorage.getItem('encuesta_completada') === 'true') {
        this.$router.push('/video?modo=foto')
      } else {
        this.mostrarAviso = true
      }
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* Botones centrados sobre la foto grupal */
.botones-col {
  position: absolute;
  top: 18%;
  right: 23%;
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.2vh, 16px);
  align-items: center;
}

.btn-nav {
  display: block;
  width: clamp(160px, 18vw, 300px);
  height: auto;
  cursor: pointer;
  transition: transform 0.15s, filter 0.15s;
}
.btn-nav:hover  { transform: scale(1.04); filter: brightness(1.08); }
.btn-nav:active { transform: scale(0.97); }

.btn-foto-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-foto-aviso {
  color: rgba(255,255,255,0.85);
  font-size: clamp(10px, 1vw, 13px);
  font-family: TelefonicaRegular, sans-serif;
  text-align: center;
  margin-top: 2px;
}

/* LAPTOP */
@media (min-width: 769px) and (max-width: 1680px) {
  .botones-col {
    top: 28%;
    right: 22%;
  }
  .btn-nav { width: clamp(140px, 14vw, 240px); }
}

/* MOBILE */
@media (max-width: 768px) {
  .botones-col {
    bottom: auto;
    top: 37%;
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    align-items: center;
    gap: 12px;
  }
  .btn-nav { width: clamp(180px, 65vw, 280px); }
}
</style>
